import { handleActions } from 'redux-actions';
import {
    setCategory,
    setStatistics,
    setCategoryImages
} from '../actions/categoryActions';

const defaultState = {
    categoryData:null,
    categoryImages:null,
    statistics:null
};

export default handleActions(
  {
      [setCategory](state, { payload }) {
          return { ...state, categoryData: payload };
      },[setCategoryImages](state, { payload }) {
          return { ...state, categoryImages: payload };
      },[setStatistics](state, { payload }) {
          return { ...state, statistics: payload };
      }
  },
  defaultState,
);
